// /config/runtimeFlags.js
// Runtime feature flags — Better-than-FAANG+
// These can be toggled by NODE_ENV, query string, or localStorage.
// Safe for CRA (no TypeScript).

const env = process.env.NODE_ENV || 'development';

/**
 * Utility: check URL query string or localStorage override.
 */
function flag(name, defaultVal = false) {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has(name)) {
      return params.get(name) !== '0' && params.get(name) !== 'false';
    }
    const ls = localStorage.getItem(`FLAG_${name}`);
    if (ls != null) {
      return ls !== '0' && ls !== 'false';
    }
  } catch {
    /* ignore */
  }
  return defaultVal;
}

const runtimeFlags = {
  imageHostAllowlist: ['res.cloudinary.com'],

  // Block expensive Cloudinary fetches in dev/localhost (serve placeholders)
  blockExternalImages: flag('blockExternalImages', env === 'development'),

  // Show verbose console logs (badges, caching, etc.)
  debugBadges: flag('DBG_BADGES', env === 'development'),

  // Enable experimental features
  enableExperimentalUI: flag('experimentalUI', false),

  // Force dark theme regardless of system preference
  forceDarkTheme: flag('forceDarkTheme', false),
};

export default runtimeFlags;
